// i18n
import { translateInComponent } from 'infras/i18n';
import translations from 'presentations/views/components/pages/PricingPage/i18n.json';

import { GetServerSideProps } from 'next';

import MainDocument from 'presentations/views/components/MainDocument';
import PricingPage from 'presentations/views/components/pages/PricingPage';
import Header from 'presentations/views/components/organisms/Header';
import { currentTeamUid } from 'usecases/auth';
import { ViewerItem } from 'presentations/api/schema/user';
import { PlanId } from 'domains/models/subscription/planId';
import { authorize } from 'presentations/api/auth';
import { pricingPath, webPath } from 'presentations/routes/path';

interface ServerProps {
  viewer: ViewerItem | null;
  teamUid: string;
  cancelPlanId: PlanId | null;
  linkCanonical: string;
}

export const getServerSideProps: GetServerSideProps = async ({
  req,
  res,
  locale,
}: any) => {
  const viewer = await authorize(req, res, {
    isRedirect: false,
    isNoTeamUserRedirect: true,
  });
  let cancelPlanId = null;
  if (req.query['cancel']) {
    cancelPlanId = Number(req.query['cancel']);
  }

  const props: ServerProps = {
    viewer,
    teamUid: await currentTeamUid(req),
    cancelPlanId,
    linkCanonical: webPath(pricingPath(), locale),
  };
  return { props };
};

export default function Page(props: ServerProps) {
  const t = translateInComponent(translations);

  return (
    <MainDocument
      title={t('title')}
      description={t('description')}
      linkCanonical={props.linkCanonical}
    >
      <PricingPage
        viewer={props.viewer}
        teamUid={props.teamUid}
        cancelPlanId={props.cancelPlanId}
        header={<Header viewer={props.viewer} />}
      />
    </MainDocument>
  );
}
